import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, from } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(): Observable<boolean> {
    return from(this.authService.waitForAuthState()).pipe(
      switchMap(() => this.authService.currentUser$),
      map(user => {
        if (user && (user.role === 'admin' || user.role === 'super_admin')) {
          return true;
        } else {
          // Redirect to home if not admin or no user
          this.router.navigate(['/home']);
          return false;
        }
      })
    );
  }
} 